<script setup>
/*
    Table widget

    Components:
        primary: <vu-table>

    Widget Properties:
        columns: [{name, width, ...}]
        pageSize: 7
        value: []
        subtitle: 'Table Title'

    CSS Properties:
 */
import {reactive, ref} from 'vue'
import {getWidgetProps} from '@/paks/vu-dash/BoardUtils'
import {clone} from '@/paks/vu-app'

defineExpose({update})

const props = defineProps({
    widget: Object,
    buttons: Array,
})

const page = reactive({
    args: {},
    data: {},
    fields: null,
    loading: null,
    select: null,
})

const primary = ref(null)

const DefaultStyles = {
    header: {
        'text-align': 'left',
        'margin-left': '20px',
    }
}

function update(params = {}) {
    let widget = props.widget
    if (params.filter && page.data) {
        // Let vu-table handle the filter
        page.data = clone(widget.value)
        return
    }
    Object.assign(page, getWidgetProps(widget, {primary}, {styles: DefaultStyles}))

    if (widget.columns) {   
        page.columns = widget.columns
    } else if (widget.fields) {
        page.columns = widget.fields.map(f => ({name: f}))
    } else {
        page.columns = null
    }
}

//  FUTURE
function buttonClick() {}
function clicked() {}

function reload() {
    State.app.setNeed('refreshData')
}
</script>

<template>
    <vu-table
        v-bind="page.args"
        ref="primary"
        class="table-widget"
        :class="widget.header ? 'table-widget-header' : ''"
        options="dynamic,filter,toolbar"
        width="100%"
        :data="page.data.primary"
        :fields="page.columns"
        :nodata="page.loading ? 'Loading...' : 'No Items'"
        :name="widget.subtitle"
        :pageSize="widget.pageSize"
        :pivot="widget.pivot"
        :select="page.select"
        :title="widget.subtitle"
        @click="clicked"
        @reload="reload">
        <template v-slot:more="props">
            <v-btn
                v-for="(btn, index) in buttons"
                class="mr-2"
                :color="index == 0 ? 'accent' : ''"
                :variant="index > 0 ? 'outlined' : 'elevated'"
                :key="btn"
                @click="buttonClick(btn)">
                {{ btn }}
            </v-btn>
        </template>
    </vu-table>
</template>

<style lang="scss">
.table-widget {
    padding: 10px 20px 20px 20px;
    font-size: 1rem;
    height:100%;
    .table-title {
        font-size: 1.4rem !important;
        padding-top: 5px;
    }
    .table-data {
        width: 100%;
    }
}
.table-widget-header {
    padding-top: 40px;
}
</style>
